import './RoundCountdown.scss'

const RoundCountdown = (props) => {
    return <div id="round-countdown">Round {props.currentRound}/{props.rounds}</div>
}

export default RoundCountdown;